import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import guides from './guides/guideContent';
import './GuidePage.css';

function GuidesIndex() {
  return (
    <div className="guide-page">
      <div className="guide-header">
        <div className="container">
          <div className="guide-header-content">
            <div>
              <h1 className="guide-header-title">
                <FontAwesomeIcon icon={faBookOpen} style={{ marginRight: '0.5rem' }} />
                How-To Guides
              </h1>
              <p className="guide-header-subtitle">
                Step-by-step instructions to help you get the most out of Church Aware
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="guides-grid">
          {guides.map((guide) => (
            <Link to={`/guides/${guide.slug}`} className="guide-card-link" key={guide.slug}>
              <div className="guide-index-card">
                <div className={`guide-index-icon ${guide.iconClass}`}>
                  <FontAwesomeIcon icon={guide.icon} />
                </div>
                <div className="guide-index-body">
                  <h2 className="guide-index-title">{guide.title}</h2>
                  <p className="guide-index-desc">{guide.description}</p>
                </div>
                <div className="guide-index-arrow">
                  <FontAwesomeIcon icon={faArrowRight} />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GuidesIndex;
